"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable */

/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
var StringUtils;

var _default = StringUtils = function () {
  var BLANK_STRING_REGEX;

  StringUtils = /*#__PURE__*/function () {
    function StringUtils() {
      _classCallCheck(this, StringUtils);
    }

    _createClass(StringUtils, null, [{
      key: "initClass",
      value: function initClass() {
        BLANK_STRING_REGEX = /^\s*$/;
      }
    }, {
      key: "capitalize",
      value: function capitalize(str) {
        if (typeof str !== 'string' || str.length === 0) {
          return '';
        }

        return str.charAt(0).toUpperCase() + str.slice(1);
      }
    }, {
      key: "isBlank",
      value: function isBlank(str) {
        return !str || BLANK_STRING_REGEX.test(str);
      } // HTML encode contents of a string, optionally preserving some nodes (ex: ["br","var"])

    }, {
      key: "escapeHTML",
      value: function escapeHTML(str, preserveNodes) {
        var index;
        var part;
        var fullParts = [{
          escaped: false,
          val: str
        }]; // Initial format, full unescaped string

        if (preserveNodes) {
          // Iteratively break the string into array of parts in format {escaped:boolean, val:str} based on supplied nodes
          // to preserve
          var matchSplit = function matchSplit(re, str) {
            // Split a string with a regexp (with assumed match capture group) and mark each part appropriately as escped
            // or not, depending on if it's from the capture group
            var parts = str.split(re);

            for (var _index = 0; _index < parts.length; _index++) {
              var _part = parts[_index];
              parts[_index] = {
                escaped: _index % 2 !== 0,
                val: _part
              };
            }

            return parts;
          }; // For each node to preserve, tokenize and split on that node, marking node as escaped


          for (var _i = 0, _Array$from = Array.from(preserveNodes); _i < _Array$from.length; _i++) {
            var node = _Array$from[_i];
            // Regexp looks for node, including permutations of start/stop tag, included attributes, and self-closing tags
            var nodeTagMatcher = new RegExp("(</?".concat(node, "[^>]*/?>)"), 'gi'); // Iterate backwards through fullParts, escaping what needs escaping via tokenization

            for (var _i2 = 0, _Array$from2 = Array.from(_.range(fullParts.length - 1, -1, -1)); _i2 < _Array$from2.length; _i2++) {
              index = _Array$from2[_i2];
              part = fullParts[index];

              if (!part.escaped) {
                var newParts = matchSplit(nodeTagMatcher, part.val); // Rebuild fullParts, replacing part with expanded newParts

                fullParts = fullParts.slice(0, index).concat(newParts).concat(fullParts.slice(index + 1));
              }
            }
          }
        } // Finally, for any parts marked as not escaped, HTML encode to text


        for (index = 0; index < fullParts.length; index++) {
          part = fullParts[index];

          if (!part.escaped) {
            var div = document.createElement('div');
            div.appendChild(document.createTextNode(part.val));
            fullParts[index].val = div.innerHTML;
          }
        } // Combine parts into just their values and return


        return fullParts.map(function (part) {
          return part.val;
        }).join('');
      }
    }]);

    return StringUtils;
  }();

  StringUtils.initClass();
  return StringUtils;
}();

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/utils/string_utils.js
// module id = 540
// module chunks = 0 15 16 17 18